export enum ExternalTransactionTypes {
  ATM_WITHDRAWAL = 'ATM_WITHDRAWAL',
  ADJUSTMENT = 'ADJUSTMENT',
  ACH_TRANSFER = 'ACH_TRANSFER',
  SWIPE_REFUND = 'SWIPE_REFUND',
  SWIPE_CASHBACK = 'SWIPE_CASHBACK',
  SWIPE = 'SWIPE',
  FEE = 'FEE',
  STORE_WITHDRAWAL = 'STORE_WITHDRAWAL',
  PAYMENT = 'PAYMENT',
  REFERRAL_GIFT = 'REFERRAL_GIFT',
  CAMPAIGN_GIFT = 'CAMPAIGN_GIFT',
  TAX_BUCKET_MANUAL_SAVE = 'TAX_BUCKET_MANUAL_SAVE',
  TAX_BUCKET_AUTO_SAVE = 'TAX_BUCKET_AUTO_SAVE',
  CHECK_DEPOSIT_REJECTED = 'CHECK_DEPOSIT_REJECTED',
  CHECK_DEPOSIT_BOUNCED = 'CHECK_DEPOSIT_BOUNCED',
  CHECK_DEPOSIT = 'CHECK_DEPOSIT',
  DEBIT_CARD_DEPOSIT = 'DEBIT_CARD_DEPOSIT',
  CHECK_DEPOSIT_FEE = 'CHECK_DEPOSIT_FEE',
  PRO_FEE = 'PRO_FEE',
  DIRECT_DEPOSIT = 'DIRECT_DEPOSIT',
  EMERGENCY_BUCKET_MANUAL_SAVE = 'EMERGENCY_BUCKET_MANUAL_SAVE',
  EMERGENCY_BUCKET_AUTO_SAVE = 'EMERGENCY_BUCKET_AUTO_SAVE',
  INTEREST = 'INTEREST',
  EMERGENCY_SAVINGS_ACCOUNT_INTEREST = 'EMERGENCY_SAVINGS_ACCOUNT_INTEREST',
  DIRECT_DEPOSIT_RETURN = 'DIRECT_DEPOSIT_RETURN',
  CASH_DEPOSIT = 'CASH_DEPOSIT',
  ACH_EXPRESS_FEE = 'ACH_EXPRESS_FEE',
  INCOMING_WIRE = 'INCOMING_WIRE',
  BILL_PAY = 'BILL_PAY',
  BILL_PAY_FEE = 'BILL_PAY_FEE',
  MAIL_CHECK = 'MAIL_CHECK',
  LILI_PLAN_FEE = 'LILI_PLAN_FEE',
  DIRECT_DEPOSIT_HOLD = 'DIRECT_DEPOSIT_HOLD',
  OUTGOING_WIRE = 'OUTGOING_WIRE',
  EXTERNAL_CREDIT_CARD = 'EXTERNAL_CREDIT_CARD',
  INTERNATIONAL_INCOMING_WIRE = 'INTERNATIONAL_INCOMING_WIRE',
  INTERNATIONAL_OUTGOING_WIRE = 'INTERNATIONAL_OUTGOING_WIRE',
}
